import { CreditMemoDetails, CreditMemoDetailsResult, getCreditMemoDetails, GetCreditMemoDetailsApiParameter } from "@dana/Services/CreditService";

import { CreditDetailsStateActions } from "@dana/Store/Data/ViewCredit/Reducers/ViewCreditDetailsReducer";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { DispatchProp } from "react-redux";

export interface GetCreditMemoDetailsParameter extends HasPagingParameters {
    creditMemoNumber?: string;
}
type HandlerType = ApiHandlerDiscreteParameter<
    GetCreditMemoDetailsParameter,
    GetCreditMemoDetailsApiParameter,
    CreditMemoDetailsResult,
    DispatchProp<CreditDetailsStateActions>
>;
export const DispatchSetParameters: HandlerType = props => {
    props.dispatch({
        type: "CreditMemoDetailsState/Init",
        isLoading: true,
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        ...props.parameter
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    
    props.apiResult = await getCreditMemoDetails(props.apiParameter);
};
export const LoadCreditMemoDetailsResponse: HandlerType = props => {
    props.dispatch({
        type: "CreditMemoDetailsState/LoadCreditDetails",
        creditMemo: props.apiResult.creditMemoDetails,
        salseOrgDetails : props.apiResult.salseOrgDetails
    });

    props.dispatch({
        type: "CreditMemoDetailsState/IsLoading",
        isLoading: false,
    });
};

export const chain = [DispatchSetParameters, PopulateApiParameter, RequestDataFromApi, LoadCreditMemoDetailsResponse];

const loadCreditMemoDetails = createHandlerChainRunner(chain, "GetCreditMemoDetails");
export default loadCreditMemoDetails;